import React from "react";

import { SelectField, TextField } from "components/AddVaccineForm/components";

import s from "./BaselineDetails.module.css";
import { FIELD_SECTIONS } from "./baselineFormConfig";

// The shared add/edit form body for a baseline reading — used by the
// Baseline tab's "Add Baseline" dialog and by the consult's own Add
// Baseline tab, so the two are always the same fields in the same layout.
export const BaselineFormFields = () => (
  <>
    {FIELD_SECTIONS.map((group) => {
      const SectionIcon = group.icon;

      return (
        <div key={group.section} className={s.formGrid}>
          <p className={s.formSectionTitle}>
            {!!SectionIcon && <SectionIcon size={14} className={s.sectionIcon} />}
            {group.section}
          </p>
          {group.fields.map((field) =>
            field.type === "select" ? (
              <SelectField
                key={field.name}
                name={field.name}
                label={field.label}
                options={field.options}
                placeholder="Select"
              />
            ) : (
              <TextField
                key={field.name}
                name={field.name}
                label={field.label}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                type={field.type === "text" ? "text" : "number"}
              />
            )
          )}
        </div>
      );
    })}
  </>
);
